export default __webpack_public_path__ + "static/media/fluxo_fgts.78fc5089.png";